<template lang="html">
    <section class="count-down container" v-if="this.$route.name === 'Dashboard' && getCountDownActived.length > 0">
        <div class="row">
            <div
                v-for="countDown in getCountDownActived"
                class="countdowns-actived"
                :key="countDown.id"
                :class="getCountDownActived.length > 3 ? 'col-md-4' : 'col-md-' + 12 / getCountDownActived.length"
            >
                <div class="countdowns-bloc">
                    <div class="header">
                        <h1>{{ countDown.name }}</h1>
                        <div class="pictoCountDown">
                            <span class="linkOrderWindow">
                                <router-link :to="{ name: 'summaryOrderWindow', params: { id: countDown.id } }">
                                    <i class="fas fa-link"></i>
                                </router-link>
                            </span>
                            <span class="infoDesc" v-b-popover.hover.right="getTranslate(countDown.terms.description)" title="Description">
                                <i class="fas fa-info-circle"></i>
                            </span>
                        </div>
                    </div>
                    <div class="countdowns-date"><Countdown :deadline="countDown.endDate"></Countdown></div>
                </div>
            </div>
            <div class="countdowns-next" v-if="getCountDownNext.length > 0">
                <button @click="nextCountdowns('listNextCountDown');">{{ $t("countdown.nextcntd") }}</button>
            </div>
        </div>
        <Modal :action="dataAction"></Modal>
    </section>
</template>

<script lang="js">
import Countdown from 'vuejs-countdown'
import {mapGetters, mapActions} from 'vuex'
import Modal from './modal/Modal'

export default {
    name: 'count-down',
    components: {
        Countdown,
        Modal
    },
    data () {
        return {
            dataAction: ''
        }
    },
    created () {
        this.listCountDown()
    },
    methods: {
        ...mapActions({
            listCountDown: 'countdown/listCountDown'
        }),
        nextCountdowns (action) {
            this.dataAction = {
                action: action
            }
            this.$root.$emit('bv::show::modal', 'defaultModal')
            console.log('modal next')
        }
    },
    computed: {
        ...mapGetters({
            getCountDown: 'countdown/getCountDown',
            getCountDownActived: 'countdown/getCountDownActived',
            getCountDownNext: 'countdown/getCountDownNext'
        })
    }
}
</script>

<style scoped lang="scss">
.count-down {
    position: relative;
    bottom: -152px;
    text-align: center;
}
.digit {
    background-color: red;
}
.countdowns {
    &-next {
        text-align: right;
        margin-top: 10px;
        width: 100%;
        & button {
            border: none;
            background: none;
            text-transform: uppercase;
            &:before {
                content: ">";
                margin-right: 5px;
            }
        }
    }
    &-bloc {
        border: 1px solid black;
        display: inline-block;
        text-align: center;
        margin: 20px auto;
        width: 100%;
        & .header {
            font-family: "oswald-regular", sans-serif;
            background: black;
            span {
                margin: 0 5px;
            }
            & h1 {
                font-family: "Roboto", sans-serif;
                color: white;
                display: inline-block;
                text-transform: uppercase;
                margin: 3px 15px;
                font-size: 23px;
                font-weight: normal;
            }
            .pictoCountDown {
                display: inline-block;
            }
            .infoDesc {
                cursor: pointer;
                font-size: 16px;
                svg {
                    color: white;
                }
            }
            .linkOrderWindow {
                font-size: 16px;
                svg {
                    color: white;
                }
            }
        }
    }
    &-date {
        padding: 10px 20px;
    }
}
</style>



// WEBPACK FOOTER //
// CountDown.vue?779997e7